import { CheckException } from '../../../arp';
import { CheckExceptionModelForSubmissionDto } from '../../types';

export const mapExceptionsForSubmission = (
    checkExceptions: Array<CheckException>
): Array<CheckExceptionModelForSubmissionDto> =>
    checkExceptions.map(exception => exception.getDtoForSubmit());
